import { Controller } from '@hotwired/stimulus';
import { RDVimeoEventCapture } from 'raindrops';
import Player from '@vimeo/player';
import { FetchRequest } from '@rails/request.js';

const percentCompleteBenchmarks = [0, 25, 50, 95, 100];

export default class extends Controller {
  static targets = ['video'];

  connect() {
    RDVimeoEventCapture.initialize(
      Player,
      (videoForm) => {
        this.convertPercentToInteger(videoForm);
        this.submitForm(videoForm);
      },
      ['play', 'pause', 'ended', 'timeupdate', 'error', 'seeked']
    );
  }

  toggleWatchedWithChild(event) {
    const formData = new FormData();
    formData.set('video_action[kind]', 'watched-together');
    formData.set('video_action[vimeo_id]', event.params.videoId);
    formData.set('video_action[current_playback_percent]', '100');
    formData.set('video_action[current_playback_time_in_s]', '0');
    formData.set('video_action[video_type]', 'SemanaHealthy::WeeklyVideo');
    (new FetchRequest('post', event.params.url, { body: formData })).perform();
  }

  videoTargetConnected(element) {
    this.videos ||= {};
    this.videos[element.dataset.videoId] ||= [];
    this.calculateVideoEventSeconds(element);
  }

  calculateVideoEventSeconds(video) {
    let player = new Player(video);
    player.getDuration().then((totalSeconds) => {
      percentCompleteBenchmarks.forEach((percentage) => {
        this.videos[video.dataset.videoId].push(
          Math.floor((parseFloat(totalSeconds) * percentage) / 100)
        );
      });
    });
  }

  eventKind(videoForm) {
    return videoForm.querySelector("[name='video_action[kind]']").value;
  }

  playbackPercent(videoForm) {
    return videoForm.querySelector(
      "[name='video_action[current_playback_percent]']"
    ).value;
  }

  convertPercentToInteger(videoForm) {
    const currentPlaybackPercent = this.playbackPercent(videoForm);
    const currentPlaybackPercentInteger = parseFloat(currentPlaybackPercent);

    videoForm.querySelector(
      "[name='video_action[current_playback_percent]']"
    ).value = Math.round(currentPlaybackPercentInteger * 100);
  }

  videoId(videoForm) {
    return videoForm.querySelector("[name='video_action[vimeo_id]']").value;
  }

  submitForm(videoForm) {
    this.addVideoType(videoForm);
    const formData = new FormData(videoForm);

    // only post timeupdate if passing specific percentages
    if (this.eventKind(videoForm) == 'timeupdate') {
      let currentSecond = videoForm.querySelector(
        "[name='video_action[current_playback_time_in_s]']"
      ).value;
      let videoMarker = document.querySelector('[data-last-second-value]');
      if (videoMarker) {
        for (let secondsTarget of this.videos[this.videoId(videoForm)]) {
          if (
            parseFloat(videoMarker.dataset.lastSecondValue) < secondsTarget &&
            secondsTarget < parseFloat(currentSecond)
          ) {
            (new FetchRequest('post', videoForm.action, { body: formData })).perform();
            break;
          }
        }
        videoMarker.dataset.lastSecondValue = currentSecond;
      }
    } else if (this.eventKind(videoForm) == 'pause') {
      if (this.playbackPercent(videoForm) !== 100) {
        (new FetchRequest('post', videoForm.action, { body: formData })).perform();
      }
    } else {
      (new FetchRequest('post', videoForm.action, { body: formData })).perform();
    }
  }

  addVideoType(videoForm) {
    if (videoForm.querySelector('[name="video_action[video_type]"]') == null) {
      const videoType = this.videoTargets[0].dataset.videoType;
      videoForm.insertAdjacentHTML('beforeend', `<input name="video_action[video_type]" value="${videoType}" />`);
    }
  }
}
